import Vue from 'vue';
import Vuex from 'vuex';
import api from '../clients/api';
import apiAuth from '../clients/apiAuth';
import router from './../router';

import { getRefreshToken, getUser, clearAccessToken, saveTokens } from './../auth';

import constants from '../constants/constants';
import users from './modules/users';
import suppliers from './modules/suppliers';
import demands from './modules/demands';
import purchaseOrder from './modules/purchaseOrders';
import purchaseOffers from './modules/purchaseOffers';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    users,
    suppliers,
    demands,
    purchaseOffers,
    purchaseOrder,
  },
  mutations: {
    login(state) {
      state.loggedIn = true;
      state.user = getUser();
    },
    logout(state) {
      state.loggedIn = false;
      state.user = {};
    },
  },
  state: {
    loggedIn: false,
    user: {},
  },
  actions: {
    login({ commit }, { email, password }) {
      console.log('(store) logging in');
      let options = {
        method: 'post',
        baseURL: constants.url.userService.baseUrl,
        url: constants.url.userService.api.login,
        headers: {
          Authorization: 'Basic ' + window.btoa(email + ':' + password),
        },
      };
      return new Promise((resolve, reject) => {
        api(options)
          .then((response) => {
            console.log('got response from api');
            saveTokens(response.data.token, response.data.refresh_token);
            commit('login');
            var re = new RegExp('(?:\\?|&)' + 'p' + '=(.*?)(?=&|$)', 'gi');
            var destination = [],
              m;
            while ((m = re.exec(document.location.search)) != null) destination[destination.length] = m[1];
            router.push({
              path:
                destination.constructor.name == 'Array' && destination.length > 0
                  ? decodeURIComponent(destination[0])
                  : 'dashboard',
            });
            resolve(response);
          })
          .catch((error) => {
            console.log('got login error');
            console.log(error);
            reject(error);
          });
      });
    },
    //eslint-disable-next-line
    register({ commit }, payload) {
      payload.role = 'supplier_selling';

      return apiAuth({
        method: 'post',
        baseURL: constants.url.userService.baseUrl,
        url: constants.url.userService.api.postUsers,
        data: payload,
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        clearAccessToken();
        commit('logout');
        resolve();
      });
    },
    refreshUser({ commit }) {
      if (getUser()) {
        commit('login');
      } else {
        commit('logout');
      }
    },
    refreshToken({ dispatch }) {
      return new Promise((resolve, reject) => {
        let options = {
          method: 'post',
          baseURL: constants.url.userService.baseUrl,
          url: constants.url.userService.api.token,
          data: {
            refresh_token: getRefreshToken(),
          },
        };
        api(options)
          .then((response) => {
            saveTokens(response.data.token, null);
            resolve(response);
          })
          .catch((error) => {
            if (error.response.data === 'expired_token') {
              reject(error);
              window.stop();
              let userEmail = getUser().email;
              dispatch('logout').then(() => {
                router.push({
                  name: 'login',
                  query: {
                    p: router.currentRoute.fullPath,
                    email: userEmail,
                  },
                });
              });
            }
            reject(error);
          });
      });
    },
    //eslint-disable-next-line
    uploadCsvFile({}, { file, url }) {
      let formData = new FormData();
      formData.append('file', file);
      console.log('(offer-upload) uploading csv file to ' + url);
      let options = {
        method: 'post',
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      return new Promise((resolve, reject) => {
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //eslint-disable-next-line
    uploadXlsxFile({}, { file, url }) {
      let formData = new FormData();
      formData.append('file', file);
      let options = {
        method: 'post',
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      return new Promise((resolve, reject) => {
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadSellingOffers() {
      return new Promise((resolve, reject) => {
        let options = {
          baseURL: constants.url.offerService.baseUrl,
          url: constants.url.offerService.api.getOffers,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //eslint-disable-next-line
    loadSellingActiveOffers() {
      return new Promise((resolve, reject) => {
        let options = {
          baseURL: constants.url.offerService.baseUrl,
          url: constants.url.offerService.api.getActiveOffers,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadDemands() {
      return new Promise((resolve, reject) => {
        let options = {
          baseURL: constants.url.demandService.baseUrl,
          url: constants.url.demandService.api.getDemandsGroupedBySku,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // eslint-disable-next-line
    loadAdminPurchaseOffers({}, { startDate, endDate }) {
      return new Promise((resolve, reject) => {
        let urlWithParams =
          constants.url.offerService.api.purchaseOffers.get + '?start=' + startDate + '&end=' + endDate;
        let options = {
          baseURL: constants.url.offerService.baseUrl,
          url: urlWithParams,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // eslint-disable-next-line
    loadAdminPurchaseOffersStock({}, { startDate, endDate }) {
      return new Promise((resolve, reject) => {
        let urlWithParams =
          constants.url.offerService.api.purchaseOffers.get +
          '?start=' +
          startDate +
          '&end=' +
          endDate +
          '&creationType=automatic';
        let options = {
          baseURL: constants.url.offerService.baseUrl,
          url: urlWithParams,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // eslint-disable-next-line
    loadAdminAcceptedPurchaseOffers({}, { startDate, endDate }) {
      return new Promise((resolve, reject) => {
        let urlWithParams =
          constants.url.offerService.api.purchaseOffers.getAccepted + '?start=' + startDate + '&end=' + endDate;
        let options = {
          baseURL: constants.url.offerService.baseUrl,
          url: urlWithParams,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkForUpdates() {
      return new Promise((resolve, reject) => {
        let options = {
          baseURL: constants.url.demandService.baseUrl,
          url: constants.url.demandService.api.getLastUpdateTimestamp,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkForPurchaseOfferUpdates() {
      return new Promise((resolve, reject) => {
        let options = {
          baseURL: constants.url.offerService.baseUrl,
          url: constants.url.offerService.api.purchaseOffers.lastUpdateTimestamp,
        };
        apiAuth(options)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});

export default store;
